var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.eligible)?_c('VueTabs',[(_vm.tab0Allowed)?_c('v-tab',{attrs:{"id":"tab0","title":_vm.$t('tabs.homo_sections')}},[_c('HomoSectionsList')],1):_vm._e(),(_vm.tab1Allowed)?_c('v-tab',{attrs:{"id":"tab1","title":_vm.$t('tabs.treatment_costs')}},[_c('TreatmentsCosts')],1):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }